import React from 'react';
import { Badge } from '../../components/ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../components/ui/table';
import { Palmtree, AlertTriangle } from 'lucide-react';
import { formatTime, formatMinutes, formatDate } from './utils';
import { StatusBadge } from './StatusCards';

export const DetailedEntriesTable = ({ entries }) => (
  <div className="rounded-lg border max-h-[400px] overflow-auto">
    <Table>
      <TableHeader className="sticky top-0 bg-background">
        <TableRow>
          <TableHead>Datum</TableHead>
          <TableHead>Mitarbeiter</TableHead>
          <TableHead>Kommen</TableHead>
          <TableHead>Gehen</TableHead>
          <TableHead className="text-right">Pausen</TableHead>
          <TableHead className="text-right">Netto</TableHead>
          <TableHead>Status</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {entries.length === 0 ? (
          <TableRow>
            <TableCell colSpan={7} className="text-center text-muted-foreground py-8">
              Keine Einträge für diesen Zeitraum
            </TableCell>
          </TableRow>
        ) : (
          entries.map((entry) => (
            <TableRow key={entry.id} className={entry.entry_type === 'vacation' ? 'bg-teal-50/50' : ''}>
              <TableCell className="font-medium">{formatDate(entry.date)}</TableCell>
              <TableCell>{entry.employee_name}</TableCell>
              <TableCell className="font-mono">
                {entry.entry_type === 'vacation' ? (
                  <Badge className="bg-teal-100 text-teal-700">
                    <Palmtree className="h-3 w-3 mr-1" />
                    {entry.vacation_type || 'Urlaub'}
                  </Badge>
                ) : (
                  formatTime(entry.clock_in)
                )}
              </TableCell>
              <TableCell className="font-mono">
                {entry.entry_type === 'vacation' ? '-' : (
                  <div className="flex items-center gap-1.5">
                    {formatTime(entry.clock_out)}
                    {entry.auto_closed && (
                      <span
                        className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300"
                        title={entry.auto_close_reason || 'Automatisch um 23:59 Uhr beendet'}
                      >
                        Auto
                      </span>
                    )}
                  </div>
                )}
              </TableCell>
              <TableCell className="text-right font-mono">
                {entry.entry_type === 'vacation' ? '-' : (entry.total_break_minutes > 0 ? `${entry.total_break_minutes} Min` : '-')}
              </TableCell>
              <TableCell className="text-right font-mono">
                {entry.entry_type === 'vacation' ? (
                  <span className="text-teal-600">8:00</span>
                ) : (
                  formatMinutes(entry.net_work_minutes)
                )}
              </TableCell>
              <TableCell>
                {entry.entry_type === 'vacation' ? (
                  <Badge className="bg-teal-100 text-teal-700">Urlaub</Badge>
                ) : (
                  <div className="flex items-center gap-2">
                    <StatusBadge status={entry.status} />
                    {!entry.break_compliance && (
                      <AlertTriangle className="h-4 w-4 text-amber-500" title="Pausenzeit unterschritten" />
                    )}
                    {entry.auto_break_applied && (
                      <Badge variant="outline" className="text-xs text-blue-600 border-blue-300" title={`${entry.auto_break_applied} Min. automatisch abgezogen`}>
                        +{entry.auto_break_applied}m
                      </Badge>
                    )}
                  </div>
                )}
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  </div>
);
